import React from "react";
import "./Footer.scss";
import githubIcon from "../../assets/icons/github-white.svg";
import linkedinIcon from "../../assets/icons/linkedin-white.svg";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer__container">
        <p className="footer__copyright">© Jensen Chan 2021</p>
        <a href="https://github.com/lyjchan0411">
          <img
            src={githubIcon}
            alt="github"
            className="footer__contact-img"
          />
        </a>
        <a href="https://www.linkedin.com/in/jensen-chan/">
          <img
            src={linkedinIcon}
            alt="linkedin"
            className="footer__contact-img"
          />
        </a>
      </div>
    </div>
  );
}
